
    <svg class="radial-progress"
         [style.width.px]="diameter"
         [style.height.px]="diameter"
         [attr.viewBox]="viewBox"
         preserveAspectRatio="xMidYMid meet"
         focusable="false">

      <circle class="radial-progress-meter"
              cx="50%"
              cy="50%"
              [attr.r]="circleRadius"
              [style.stroke-width.%]="circleStrokeWidth"/>

      <circle class="radial-progress-value"
              cx="50%"
              cy="50%"
              [attr.r]="circleRadius"
              [style.stroke-dashoffset.px]="strokeDashOffset"
              [style.stroke-dasharray.px]="strokeCircumference"
              [style.stroke-width.%]="circleStrokeWidth"/>
    </svg>
  